module.exports = __webpack_public_path__ + "static/4-9c52ea792b577956e0b095791acfe87c.png";